<template>

	<v-main v-if="eventos.length > 0" class="mt-6">
		<v-container class="my-sm-0 d-flex flex-column ">
			<v-row class="d-inline-block ">
				<h3 class="text-h3 text-center text-md-left font-weight-bold">
					Eventos
				</h3>
			</v-row>
			<v-row>

				<v-col class="d-flex justify-content-center flex-column">
					<!-- GIRA  -->

					<v-window v-show="$vuetify.breakpoint.xs" reverse v-for="(imagengira, index) in girasinicio"
						:key="index + 30">
						<router-link :to="{
							name: 'giras',
							params: {
								gira: imagengira.slug,
							},
						}">
							<v-window-item :key="index + 30" :src="imagengira.url"
								lazy-src="/img/logo-ticketshop.ca82ecc6.png">
								<v-col class="p-0 ">
									<v-card fill-higth max-width="320" max-height="240" outlined class="d-flex rounded-lg">
										<v-img :aspect-ratio="9 / 16" width="160" max-width="160" height="240"
											class="rounded-lg fill-height" :src="imagengira.url">
										</v-img>
										<v-col width="160" max-width="320"
											class="d-flex flex-column justify-content-center px-2 py-3 py-md-6">
											<v-text>
												<v-card-title
													class="onSurface--text mb-0 pa-0 text-body-1 font-weight-bold text-break">
													{{ imagengira.nombre }}
												</v-card-title>
												<p class="onSurfaceVariant--text mb-0 body-2">
													{{
														formatFecha(
															imagengira.fechaini
														)
													}}
													-
													{{
														formatFecha(
															imagengira.fechafin
														)
													}}
												</p>
											</v-text>
											<v-spacer></v-spacer>
											<v-text class="mt-0 body-2">GIRA</v-text>

											<v-card-subtitle v-if="imagengira.status == 0" height="16"
												class="p-0 m-0 success--text" style="
													font-family: Montserrat;
													font-size: 11px;
													font-style: normal;
													font-weight: 500;
													line-height: 16px; /* 145.455% */
													letter-spacing: 0.5px;
												">
												<v-icon color="success" fill-height size="10">mdi-checkbox-blank-circle</v-icon>
												Disponible
											</v-card-subtitle>
											<v-spacer></v-spacer>

											<router-link :to="{
												name: 'giras',
												params: {
													gira: imagengira.slug,
												},
											}">
												<v-btn max-width="128" class="m-0 mt-md-2" small rounded color="primary">
													Comprar Entradas
												</v-btn>
											</router-link>
										</v-col>
									</v-card>
								</v-col>
							</v-window-item>
						</router-link>
					</v-window>



				</v-col>

				<!-- Escritorio -->
				<v-container class="d-flex ma-0 px-0">
					<!-- GIRA -->
					<v-col v-for="(imagengira, index) in girasinicio" :key="index + 30">
						<router-link :to="{
							name: 'giras',
							params: {
								gira: imagengira.slug,
							},
						}">

							<v-col lazy-src="/img/logo-ticketshop.ca82ecc6.png">
								<v-col class="p-0">
									<v-card fill-higth width="512" height="320" outlined
										class="d-flex flex-row rounded-lg  hover-card ">
										<v-img :aspect-ratio="2 / 3" fill-height class="rounded-lg pa-0 ma-0 img-animation"
											:src="imagengira.url" :key="index + 30">
										</v-img>

										<v-col width="128" min-width="320" class="d-flex flex-column wrap ml-4 px-4 py-3 py-md-6">
											<v-text>
												<v-card-title
													class="onSurface--text mb-0 pa-0 headline font-weight-bold text-break hover-card-title">
													{{ imagengira.nombre }}
												</v-card-title>
												<p class="onSurfaceVariant--text mb-1 subtitle-1">
													{{
														formatFecha(
															imagengira.fechaini
														)
													}}
													-
													{{
														formatFecha(
															imagengira.fechafin
														)
													}}
												</p>
											</v-text>
											<v-spacer></v-spacer>
											<v-text class="mt-0 body-1">GIRA</v-text>
											<v-card-subtitle class="p-0 m-0  body-1 text--darken-4 green--text  ">
												<v-icon class="text--darken-4 green--text" fill-height
													size="12">mdi-checkbox-blank-circle</v-icon>
												<v-text text-color="green darken-4"> Disponible</v-text>
											</v-card-subtitle>
											<v-spacer></v-spacer>
											<router-link :to="{
												name: 'giras',
												params: {
													gira: imagengira.slug,
												},
											}">
												<v-btn class="d-flex align-self-baseline custom-btn" rounded color="primary">
													Comprar Entradas
												</v-btn>
											</router-link>
										</v-col>
									</v-card>
								</v-col>
							</v-col>

						</router-link>
					</v-col>

					<!-- Eventos -->
					<v-row class="d-flex justify-content-center   px-0 ">
						<v-col cols="12" sm="10" lg="6" lazy-src="@/assets/icons/logo-ticketshop-carousel.png"
							v-for="(evento, index) in eventos" :key="index">




							<router-link :to="{
								name: 'evento',
								params: {
									evento: evento.slug,
								},
							}">
								<!-- Escritorio -->



								<v-card fill-higth :width="$vuetify.breakpoint.xsOnly ? 320 : 512"
									outlined
									class="d-flex rounded-lg mx-auto overflow-hidden hover-card">
									<v-col cols="6"  class="ma-0 pa-0">
										<v-img
											v-for="(imagen, index) in evento.imagens.filter(img => img.nombre.includes('imagen_card_desktop'))"
											:key="index" :aspect-ratio="2 / 3" fill-height
											class="rounded-lg pa-0 ma-0 img-animation d-none d-md-flex" :src="imagen.url">


										</v-img>
										<v-img :key="index"
											v-for="(imagen, index) in evento.imagens.filter(img => img.nombre.includes('imagen_card_mobile'))"
											:aspect-ratio="2 / 3" class="rounded-lg pa-0 ma-0 img-animation d-flex d-md-none"
											:src="imagen.url">


										</v-img>

									</v-col>
									<v-spacer></v-spacer>

									<v-col cols="6" class="d-flex flex-column wrap ">
										<v-text>
											<v-card-title
												class="onSurface--text mb-0 pa-0 text-sm-h5 text-lg-h4 text-h6 font-weight-bold text-break" style="line-height: 1.2;">
												{{ evento.nombre }}
											</v-card-title>
											<v-text class="onSurfaceVariant--text mb-1 text-md-title  subtitle-1">
												{{
													formatFecha(
														evento.fecha_evento
													)
												}}
											</v-text>
										</v-text>
										<v-spacer></v-spacer>
										<v-text class="mt-0 caption outline--text">{{
											evento.tipoevento.nombre
										}}</v-text>
										<v-card-subtitle class="p-0 m-0 subtitle-1 text--darken-4 green--text  ">
											<v-icon class="text--darken-4 green--text" fill-height
												size="12">mdi-checkbox-blank-circle</v-icon>
											<v-text text-color="green darken-4"> Disponible</v-text>
										</v-card-subtitle> 
										<v-spacer ></v-spacer>
										<router-link :to="{
											name: 'evento',
											params: {
												evento: evento.slug,
											},
										}">
											<v-btn v-if="$vuetify.breakpoint.smAndUp" block
												class="d-flex align-self-baseline custom-btn mb-4" rounded color="primary">
												<v-text>
													Comprar Entradas
												</v-text>
											</v-btn>
										</router-link>

									</v-col>
									<v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
								</v-card>



							</router-link>

						</v-col>
					</v-row>
				</v-container>

			</v-row>
		</v-container>


	</v-main>
	<div v-else class="text-center animated fadeInUp">
		<h1 style="color: #8c8c8c">
			<i class="material-icons" style="font-size: 100px">hourglass_empty</i><br />
			Upss. No se encontraron eventos...
		</h1>
	</div>


</template>
<script>
import moment from "moment";
import axios from "axios";
import { configApi } from "../../api/configApi";
import { headers } from "../../api/headers";
export default {
	props: [
		"precioInicio",
		"precioFin",
		"artistasFilter",
		"tiposEventosFilter",
		"fechaInicio",
		"fechaFin",
		"ciudadeseventosFilter",
		"eventos"
	],

	mounted() {
		// this.getImagenVal = this.eventos;
	},
	async beforeCreate() { },
	async created() {
		// this.$store.dispatch('evento/getImagenesEvento', this.eventos.id);
		await this.newvasgiras();
	},
	data() {
		return {
			// getImagenVal: [],
			// urlImg: [],
			giras: [],
			firstPinter: true,
			girasinicio: [],
		};
	},
	computed: {
		paginationEventos() {
			return this.$store.getters["evento/pagination"];
		},
		pagesEventos() {
			return this.$store.getters["evento/pages"];
		},
		totalItemCount() {
			return this.$store.getters["evento/totalItemCount"];
		},
		loading() {
			return this.$store.getters["evento/loading"];
		},
	},
	methods: {
		async newvasgiras() {
			await axios
				.get(`${configApi.apiUrl}banner_gira`, null, {
					headers: headers,
				})
				.then((response) => {
					this.girasinicio = response.data.items.map((item) => ({
						id: item.id,
						nombre: item.nombre,
						url: item.imagen2,
						slug: item.slug,
						status: item.estado,
						fechaini: item.fecha_ini,
						fechafin: item.fecha_fin,
					}));
				});
		},
		changePage(page) {
			this.$store.commit("evento/changePage", page);
			this.$store.dispatch("evento/listEventosStatus", {
				page: page,
				status: 1,
			});
		},
		formatFecha(fecha) {
			if (fecha != null && fecha != "") {

				return moment(fecha).format("MMMM, DD YYYY");
			} else {
				return "";
			}

		},
	},
};
</script>
<style scoped>
.hover-card {
	transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.hover-card:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	border: 1px solid #FFDF6C;

}

.hover-card:focus-within {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>